import React, { useState, useEffect } from 'react';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { Navigate } from 'react-router-dom';
import Footer from './components/Footer';
import './CreateAccount.css';

const firebaseAPIKey = process.env.REACT_APP_FIREBASE_API_KEY;

const firebaseConfig = {
  apiKey: firebaseAPIKey,
  authDomain: "property-ranker.firebaseapp.com",
  projectId: "property-ranker",
  storageBucket: "property-ranker.firebasestorage.app",
  messagingSenderId: "392160926638",
  appId: "1:392160926638:web:32df7465675b7cb785063f",
  measurementId: "G-W9CBC2L5F4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      const friendlyMessage = getErrorMessage(error.code);
      setMessage(`Login failed: ${friendlyMessage}`);
    }
  };

  const firebaseErrorMessages = {
    "auth/invalid-email": "The email address is not valid.",
    "auth/user-disabled": "This user account has been disabled.",
    "auth/user-not-found": "No user found with this email. Please check and try again.",
    "auth/wrong-password": "Incorrect password. Please try again.",
    "auth/email-already-in-use": "This email is already in use. Please use another email.",
    "auth/weak-password": "The password is too weak. Please choose a stronger password.",
    "auth/operation-not-allowed": "This operation is not allowed. Please contact support.",
    "auth/network-request-failed": "Network error. Please check your connection and try again.",
  };

  function getErrorMessage(errorCode) {
    return firebaseErrorMessages[errorCode] || "Please try again.";
  }

  if (user) {
    return <Navigate to="/properties" replace />;
  }

  return (
    <div>
      <div className="create-account-container">
        <div className="left-container">
          <div className="form-container">
            <h1><img src='/imgs/domorango.png' alt="Domogogo" className="" style={{maxWidth:"200px", paddingBottom:"30px"}} /></h1>
            <h2>Login to Your Account</h2>
            <p>Enter your details below to log in</p>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
            />
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
            />
            <button onClick={handleLogin} className="submit-button">LOGIN</button>
            <div style={{ paddingTop: "10px" }}>
              <a href='/reset-password' style={{ color: 'white' }}>Forgotten Password?</a>
            </div>
            <div style={{ paddingTop: "10px" }}>
              <a href='/create-account' style={{ color: 'white' }}>Don't have an account? Sign up here</a>
            </div>
            {message && <p className="error-message">{message}</p>}
          </div>
        </div>
        <div 
          className="image-container" 
          style={{ backgroundImage: "url('/imgs/bighouse.png')", backgroundSize: "cover", backgroundPosition: "center" }}
        ></div>
      </div>
      <Footer />
    </div>
  );
}

export default Login;
